import { QueryClient } from 'react-query';
import { handleMutationError, handleQueryError } from './error-handler';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      useErrorBoundary: false,
      onError: (error: unknown) => {
        // Log all query errors to Sentry with context
        // Note: We don't have access to query object in the global onError
        // Individual queries should provide their own onError for specific context
        handleQueryError(error, {
          hookName: 'unknown-query',
          showToast: false // Queries typically fail silently
        });
      }
    },
    mutations: {
      useErrorBoundary: false,
      retry: false,
      onError: (error: unknown) => {
        // Log all mutation errors to Sentry with context
        // Note: We don't have access to mutation object in the global onError
        // Individual mutations should provide their own onError for specific context
        handleMutationError(error, {
          hookName: 'unknown-mutation',
          showToast: true // Mutations should notify users by default
        });
      }
    }
  }
});
